import React from "react";

function QueryModelEmbeddingTypeSelect({ value, onChange }) {
  const handleChange = (event) => {
    const selectedValue = event.target.value;
    onChange(selectedValue);
  };

  return (
    <div className="mb-3">
      <label htmlFor="queryModelEmbeddingTypeSelect" className="form-label">
        Query Model Embedding Type
      </label>
      <select className="form-select" id="queryModelEmbeddingTypeSelect" value={value} onChange={handleChange}>
        <option value="aggregated">Aggregated</option>
        <option value="embedding">Embedding</option>
      </select>
    </div>
  );
}

export default QueryModelEmbeddingTypeSelect;
